import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b34ae3ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-container" }
const _hoisted_2 = { class: "desktop" }
const _hoisted_3 = { class: "hide-mobile" }
const _hoisted_4 = { class: "right-side" }
const _hoisted_5 = { class: "mobile" }

import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import { NDrawer, NDrawerContent } from 'naive-ui';
import { useRoute } from 'vue-router';
import BaseMenuItem from '@/components/layout/Menu/BaseMenuItem.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { path } = useRoute();
const { dispatch, getters } = useStore();
const isMobileMenuShow = ref<boolean>(false);
const rights = computed(() => getters['auth/rights']);
const logout = async () => {
	await dispatch('auth/logout');
};
const showMobileMenu = async () => {
	isMobileMenuShow.value = true;
};

const menuItems = computed<MenuItem[]>(() =>
	[
		{
			id: 'homepage',
			to: '/',
			label: 'Homepage',
			isHideLabelDesktop: true,
			icon: 'fal fa-home-lg-alt',
			isActive: path === '/',
			isDesktopMain: true,
			isDesktopRightSide: false,
			isMobile: true,
			isAuthorized: true,
		},
		{
			id: 'measurement',
			to: '/mereni',
			label: 'Měření',
			icon: 'fal fa-analytics',
			isActive: !!path.match('/mereni'),
			isDesktopMain: true,
			isDesktopRightSide: false,
			isMobile: true,
			isAuthorized: true,
		},
		{
			id: 'validateUrl',
			to: '/validace-url',
			label: 'Kontrola URL',
			icon: 'fas fa-earth-americas',
			isActive: !!path.match('/validace-url'),
			isDesktopMain: true,
			isDesktopRightSide: false,
			isMobile: true,
			isAuthorized: true,
		},
		{
			id: 'settings',
			to: '/nastaveni',
			isHideLabelDesktop: true,
			label: 'Nastavení',
			icon: 'fal fa-cog',
			isActive: !!path.match('/nastaveni'),
			isDesktopMain: false,
			isDesktopRightSide: true,
			isMobile: true,
			isHideOnMobile: true,
			isAuthorized: rights.value.admin,
		},
		{
			id: 'myAccount',
			to: '/muj-ucet',
			isHideLabelDesktop: true,
			label: 'Můj účet',
			icon: 'fal fa-user',
			isActive: !!path.match('/muj-ucet'),
			isDesktopMain: false,
			isDesktopRightSide: true,
			isMobile: true,
			isHideOnMobile: true,
			isAuthorized: true,
		},
		{
			id: 'space-1',
			isHideLabelDesktop: true,
			isActive: false,
			isDesktopMain: false,
			isDesktopRightSide: false,
			isMobile: true,
			isAuthorized: true,
		},
		{
			id: 'logout',
			onClick: logout,
			isHideLabelDesktop: true,
			label: 'Odhlásit se',
			icon: 'fal fa-power-off',
			isActive: false,
			isDesktopMain: false,
			isDesktopRightSide: true,
			isMobile: true,
			isHideOnMobile: true,
			isAuthorized: true,
		},
		{
			id: 'menu',
			onClick: showMobileMenu,
			isHideLabelDesktop: true,
			label: 'Menu',
			icon: 'fal fa-bars',
			isActive: false,
			isDesktopMain: false,
			isDesktopRightSide: true,
			isMobile: false,
			isHideOnDesktop: true,
			isAuthorized: true,
		},
	].filter((item: MenuItem) => item.isAuthorized)
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo"
      }),
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems).filter((item) => item.isDesktopMain), (menuItem) => {
            return (_openBlock(), _createElementBlock("li", {
              key: menuItem.id
            }, [
              _createVNode(BaseMenuItem, {
                "menu-item": menuItem,
                "is-small": ""
              }, null, 8, ["menu-item"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("nav", _hoisted_4, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems).filter((item) => item.isDesktopRightSide), (menuItem) => {
            return (_openBlock(), _createElementBlock("li", {
              key: menuItem.id,
              class: _normalizeClass({
						'hide-mobile': menuItem.isHideOnMobile,
						'hide-desktop': menuItem.isHideOnDesktop,
					})
            }, [
              _createVNode(BaseMenuItem, { "menu-item": menuItem }, null, 8, ["menu-item"])
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_unref(NDrawer), {
      show: isMobileMenuShow.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((isMobileMenuShow).value = $event)),
      width: 250,
      placement: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NDrawerContent), {
          title: "Menu",
          closable: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("nav", _hoisted_5, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems).filter((item) => item.isMobile), (menuItem) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: menuItem.id
                  }, [
                    _createVNode(BaseMenuItem, {
                      "menu-item": menuItem,
                      "is-mobile": ""
                    }, null, 8, ["menu-item"])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})